module.exports = __webpack_public_path__ + "img/hcgl.8a37edd8.png";